export enum EnvName
{
  LOCAL = 'local',
  STG = 'staging',
  PROD  = 'production',
}
